module.exports = __webpack_public_path__ + "static/media/banner.480bbcf3.png";